export default [
  {
    path: '/template/:id',
    name: 'website-template-home',
    component: () => import('@/views/website/home/Index.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/preview/:id',
    name: 'website-preview-home',
    component: () => import('@/views/website/home/Index.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/',
    name: 'website-website-home',
    component: () => import('@/views/website/home/Index.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/template/:id/search',
    name: 'website-template-search',
    component: () => import('@/views/website/content/Search.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/preview/:id/search',
    name: 'website-preview-search',
    component: () => import('@/views/website/content/Search.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/search',
    name: 'website-website-search',
    component: () => import('@/views/website/content/Search.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/template/:id/content/list/:columnId',
    name: 'website-template-content-list',
    component: () => import('@/views/website/content/List.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/preview/:id/content/list/:columnId',
    name: 'website-preview-content-list',
    component: () => import('@/views/website/content/List.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/content/list/:columnId',
    name: 'website-website-content-list',
    component: () => import('@/views/website/content/List.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/template/:id/content/single/:columnId',
    name: 'website-template-content-single',
    component: () => import('@/views/website/content/Single.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/preview/:id/content/single/:columnId',
    name: 'website-preview-content-single',
    component: () => import('@/views/website/content/Single.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/content/single/:columnId',
    name: 'website-website-content-single',
    component: () => import('@/views/website/content/Single.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/template/:id/content/custom/:columnId/:pageTypeId',
    name: 'website-template-content-custom',
    component: () => import('@/views/website/content/Customer.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/preview/:id/content/custom/:columnId/:pageTypeId',
    name: 'website-preview-content-custom',
    component: () => import('@/views/website/content/Customer.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/content/custom/:columnId/:pageTypeId',
    name: 'website-website-content-custom',
    component: () => import('@/views/website/content/Customer.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/template/:id/content/detail/:columnId/:materialId',
    name: 'website-template-content-detail',
    component: () => import('@/views/website/content/Detail.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/preview/:id/content/detail/:columnId/:materialId',
    name: 'website-preview-content-detail',
    component: () => import('@/views/website/content/Detail.vue'),
    meta: { layout: 'website' },
  },
  {
    path: '/content/detail/:columnId/:materialId',
    name: 'website-website-content-detail',
    component: () => import('@/views/website/content/Detail.vue'),
    meta: { layout: 'website' },
  },

  /* ------------------------ */

  {
    path: '/404',
    name: 'error-404',
    component: () => import('@/views/empty/error/Error404.vue'),
    meta: { layout: 'empty', noTab: true },
  },
  {
    path: '/500',
    name: 'error-500',
    component: () => import('@/views/empty/error/Error500.vue'),
    meta: { layout: 'empty', noTab: true },
  },
  {
    path: '/:catchAll(.*)',
    name: 'error-all',
    component: () => import('@/views/empty/error/Error404.vue'),
    meta: { layout: 'empty', noTab: true },
  },
];
